(ns app.front.view.attachment.common
  (:require [app.domain.attachment.model :as attachment-model]
            [app.front.ui :as ui]
            [clojure.string :as str]
            [clojure.walk :as walk]
            [core.front.event :refer [<sub]]
            [goog.object :as go]
            [potpuri.core :as p]
            [schema-tools.core :as st]
            [schema.core :as s]))

(defn attachment-type-label [attachment-type lang]
  (attachment-model/attachment-type-label attachment-type lang))

(defn types-str [tr attachment-types]
  (let [lang   (<sub [:language])
        labels (->> (mapv #(attachment-type-label % lang) attachment-types)
                    sort
                    seq)]
    (if labels
      (str/join ", " labels)
      (tr [:select-option]))))

(defn keywords-from-multi-select [e]
  (let [items (->> (go/get e "selectedItems")
                   js->clj
                   walk/keywordize-keys)]
    (mapv #(-> % :id) items)))

(defn attachment-types-text [types]
  (let [lang (<sub [:language])]
    (->> (mapv #(attachment-type-label % lang) types)
         sort
         (str/join ", "))))

(defn attachment-link [id & [download?]]
  {:pre [(integer? id)]}
  (str
    "/api/command/attachment/latest-file-version?attachment-id=" id
    (when download?
      "&download=true")))

(defn attachment-version-link [id file-id & [download?]]
  {:pre [(integer? id)]}
  (str
    "/api/command/attachment/file-version?attachment-id=" id
    "&file-id=" file-id
    (when download?
      "&download=true")))

(s/defschema VisibilityDetailsOptions
  (st/merge
    {:tr          (s/pred fn?)
     :owner-name  s/Str
     :restricted? s/Bool}
    (st/optional-keys
      {:on-click (s/pred fn?)})))

(s/defn visibility-details
  [{:keys [tr owner-name restricted? on-click]} :- VisibilityDetailsOptions]
  [:div.py-4.flex.flex-row.flex-wrap.gap-4.items-center
   [:div.font-bold.w-full.sm:w-auto (tr [:attachment/file-visibility])]
   [ui/small-pill
    (p/assoc-if {:kind (if restricted? :secondary :primary)}
                :on-click (when (and restricted? on-click)
                            #(on-click false)))
    (tr [:attachment/everyone])]
   [ui/small-pill
    (p/assoc-if {:kind (if restricted? :primary :secondary)}
                :on-click (when (and (not restricted?) on-click)
                            #(on-click true)))
    (tr [:attachment/restricted])]
   [:span (if restricted?
            (tr [:attachment/restricted-help] [owner-name])
            (tr [:attachment/everyone-help]))]])
